import { useEffect, useState } from "react";
import {useLocation, useNavigate} from 'react-router-dom';
import { ErrorContext } from "../../utils/context/error";
import { getUserPermission, setUserPermission } from "../../services/user";
import Icon from "../../Icons/general/Icon";
import Cardview from "./cardview";

function AsignPermisse() 
{
    const location = useLocation();
    const navigate = useNavigate();
   
    const { setShowToast, setOpciones } = ErrorContext();
    const [ UsuarioId, setUsarioId ] = useState(location.state?.Id);
    const [habilita, setHabilita] = useState(false);
    const [ Permisos, setPermisos ] = useState([]);
    const [ Usuarios, setUsuarios ] = useState([]);
    const [ Detalles, setDetalle ] = useState([]);
    const [ Items, setItems ] = useState([]);
    const [frmData, setFrmData] = useState([]);
    const [ numeroNit ] = useState(location.state?.numeroNit);
    const [ nombre ] = useState(location.state?.nombre);
    const [ estadof ] = useState(location.state?.estadof);
    
    
    //------------------------------------------------------------------------------------------------------------------
    const fillParamsIni = async() =>
      {
         if (UsuarioId > 0)
           {
              const response = await getUserPermission(UsuarioId);
              if (response) 
                {
                   if (response.status === 200) 
                    {
                       setPermisos(response.data.data);
                       setUsuarios(response.data.user);
                       setDetalle(response.data.detalle);
                       setItems(response.data.items);
   
                    } 
                   else 
                   {
                      const Mensaje = response.message;
                      const opc = { type: "Danger", message: Mensaje, active: true };
                      setOpciones(opc);
                      setShowToast(true);
                   }
                }
            }
       }
    //------------------------------------------------------------------------------------------------------------------   
    const CargarDatos=() =>
    {
     setFrmData(
        Items.map(i => {
           const existe = Detalles.some(a =>
              Number(a.MenuId) === Number(i.MenuId) &&
              Number(a.ItemId) === Number(i.ItemId)
           );

           return {
             MenuId: Number(i.MenuId),
             ItemId: Number(i.ItemId),
             Estado: existe ? 'SI' : 'NO'
           };
        })
      );
    }
    //------------------------------------------------------------------------------------------------------------------
    const handleAceptar = async() =>
      {
         setHabilita(true);
         const response = await setUserPermission(UsuarioId, frmData);
         if (response) 
          {
             if (response.status === 200) 
              {
                 navigate('/home/user', {
                    state: { Id: UsuarioId, numeroNit, nombre, estadof, fromPermisos: true}
                  });
              } 
             else 
             {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
             }
          }
         setHabilita(false);
      }
    //------------------------------------------------------------------------------------------------------------------
    const handleCancel = async () => 
    {
      //navigate(-1)  
      navigate('/home/user', {
        state: { Id: UsuarioId, numeroNit, nombre, estadof, fromPermisos: true }
       });
    };
    //------------------------------------------------------------------------------------------------------------------
    useEffect(() => 
     {
      setHabilita(false);
      fillParamsIni();
     }, []);
    //------------------------------------------------------------------------------------------------------------------
    useEffect(() => 
     {
       if (Items.length > 0) 
        {
         CargarDatos();
        }
      }, [Items]);
    
    return(<>
          <div className="flex flex-col w-full border border-disabled h-[85vh] overflow-y-auto">
            <div className="flex w-full flex-row h-[7rem] border-b border-disabled">
              <div className="flex w-[7rem] h-[7rem] bg-disabled items-center justify-center">
                  <Icon svg="infocircle" className="w-[4rem] h-[4rem] fill-light"></Icon>
              </div>
              <div className="flex flex-col w-full items-start justify-center">
                   <div className="flex flex-row w-full space-x-1">
                      <span className="text-right w-[5.2rem] text-gray-700 font-semibold">Codigo : </span>
                      <span className="text-gray-600">{Usuarios?.CodigoUsr}</span>
                   </div>
                   <div className="flex flex-row w-full space-x-1">
                      <span className="text-right w-[5.2rem] text-gray-700 font-semibold">Nombre : </span>
                      <span className="text-gray-600">{Usuarios?.NombreUsr}</span>
                   </div>
                   <div className="flex flex-row w-full space-x-1">
                      <span className="text-right w-[5.2rem] text-gray-700 font-semibold">Cargo : </span>
                      <span className="text-gray-600">{Usuarios?.NombreCar}</span>
                   </div>
              </div>
            </div>
            
            <div className="flex flex-1 overflow-auto flex-row w-full flex-wrap gap-x-3 gap-y-3 p-4">
               {Permisos.map((item) => {
                let Datos = Items.filter(deta => deta.MenuId === item.MenuId);
                 return (
                   <div key={item.MenuId}>

                     <Cardview data={item} detalle={Datos} frmData={frmData} setFrmData={setFrmData}></Cardview>
                   </div>
                  );
                })}
            </div>
        </div>
        <div className="flex sticky bottom-0 mt-2 w-full gap-4 justify-end">
             <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
             <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
        </div>        
                  
    </>);
}
export default AsignPermisse;